import React,{useState} from 'react'
import SalaryCalculationForm from './SalaryCalculationForm';
import SalaryCalculationList from './SalaryCalculationList';

const SalaryCalculation = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);

return (
  <>
    {fromIsShown ? (
        <SalaryCalculationForm addForm={setFromIsShown} update={upData} />
      ) : (
        <SalaryCalculationList addForm={setFromIsShown} update={setUpData} />
      )}

  </>
)
}

export default SalaryCalculation